import React from 'react';
import CompanyForm from './CompanyForm';

const EditCompany: React.FC = () => {
  return <CompanyForm isEditMode={true} />;
};

export default EditCompany;